import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createEndorsementUnderReviewSlice = (set, get) => ({
    endorsementUnderReview: {
        loading: false,
        data: [],
        comments: []
    },
    getEndorsementUnderReview: async () => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ endorsementUnderReview: { ...state.endorsementUnderReview, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: "get",
                baseURL: config.apiUrls(),
                url: "v1/business/endorsement/under-review-report",
                headers: { token },
            });
            set(state => ({ endorsementUnderReview: { loading: false, data: resp.data } }));
        } catch (error) {
            set(state => ({ endorsementUnderReview: { ...state.endorsementUnderReview, loading: false } }));
        }
    }
});
